module.exports = __webpack_public_path__ + "static/media/handShake.92521f68.svg";